var exports = {
  "kL": "x804f0401--f627c8--container",
  "d4": "x804f0401--f627c8--star",
  "vu": "x804f0401--f627c8--active",
  "PT": "x804f0401--f627c8--hover",
};

module.exports = exports;
